// react imports
import React, { useEffect } from "react"

// package imports
import { Col, Row } from "react-bootstrap"

// project imports
import { NextButton } from "components"
import * as Constants from "constants/Constants";
import QmsQuoteStatus from "constants/QmsQuoteStatus"
import qmsDashboardPageStore from "modules/qms-flow/qms-dashboard-page/qms-dashboard-page-store"

import "./proposer-details-card.css"
import QmsStorageKeys from "constants/QmsStorageKeys";
import StorageKeys from "constants/StorageKeys";
import AuthStore from "modules/login/store/AuthStore";
import qmsOldPackageIsList from "constants/qmsOldPackageIsList";
import setCookie from "utils/journeyIdCookie/setJourneyId";
import { observer } from "mobx-react";

const policyResumeUrl = process.env.REACT_APP_QMS_TO_PRAGATI_POLICY_RESUME_URL
const policyAppTrackerUrl = process.env.REACT_APP_QMS_TO_PRAGATI_POLICY_APP_TRACKER_URL
const qmsDashboardUrl = process.env.REACT_APP_QMS_DASHBOARD_URL

function ProposerDetailsCardForApplicationInProgress(props) {
    const { proposerData, proposerIndex, laIndex, quotationIndex, quoteStatusData, buttonId, statusId, journeyData, showSingleCard } = props

    let channelName = Constants.NEW_QMS_CHANNEL_LIST
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];

    useEffect(() => {
        if (buttonId && quoteStatusData.status) {
            const buttonElement = document.getElementById(buttonId);
            if (buttonElement) {
                document.getElementById(buttonId).style.backgroundColor = quoteStatusData.button_color
                document.getElementById(buttonId).style.borderColor = quoteStatusData.button_color
                document.getElementById(buttonId).style.color = quoteStatusData.button_text_color
            }
        }

        if (statusId && quoteStatusData.status) {
            document.getElementById(statusId).style.color = quoteStatusData.status_text_color
        }

        if (showResumeAnalysisButton(journeyData.product_coverage_list)) {
            document.getElementById(buttonId).style.backgroundColor = "#f76f8b"
            document.getElementById(buttonId).style.borderColor = "#f76f8b"
            document.getElementById(buttonId).style.color = "#333333"
        }

    }, [quoteStatusData.buttonId, quoteStatusData.solutionId, quoteStatusData.status])

    const onViewDetailsClick = async () => {

        let buttonTextConstant = qmsDashboardPageStore.qmsButtonConstant(quoteStatusData?.button_text)
        await qmsDashboardPageStore.saveQMSUserClicks(buttonTextConstant, journeyData?.journey_id)

        let quotationStatusFormObj = document.getElementById(`quotation-status-form-post-call-${statusId}`);
        console.log("quotationStatusFormObj formObj :: ", quotationStatusFormObj);
        quotationStatusFormObj.submit();
    }

    const showResumeAnalysisButton = (productCoverageList) => {

        let oldPackagelist = qmsOldPackageIsList
        let list = productCoverageList
        let allValuesMatch = list?.some(item => oldPackagelist.includes(item?.package_id))

        return allValuesMatch
    }

    const onClickResumeAnalysis = async () => {

        let routeName = "customization"
        setCookie("journeyId", journeyData?.journey_id);

        localStorage.setItem('directedFromQMS', true);
        localStorage.setItem('routeName', routeName)
        localStorage.setItem(StorageKeys.LANDING_FROM_QMS, true);
        localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false);
        // props.history.push(`/${routeName}/${journeyData.journey_id}?agent_id=${agentId}&token=${token}`) 
        await AuthStore.fetchAllData(journeyData.journey_id)
        props.history.push(`/${routeName}`)

    }

    return (
        <>
            <Col md="2" className="card-inner-padding">
                {(laIndex === 0 && proposerIndex === 0 && quotationIndex === 0) &&
                    <>
                        <p className="mb-0 font-size-14 font-weight-medium client-name">{qmsDashboardPageStore.getFamilyMemberName(proposerData, false, journeyData, true)} {showSingleCard && proposerData.proposer_member_type}</p>
                        {proposerData?.mobile_number && <a href={`tel:${proposerData.mobile_number}`} className="font-size-12 font-weight-400 mb-0 mr-1 mobile-number">{proposerData.mobile_number}</a>}
                    </>
                }
            </Col>

            <div className='d-none d-md-block border-right mx-md-3'></div>
            <div className='d-block d-md-none border-bottom w-100 mx-md-3'></div>

            <Col md="3" className="card-inner-padding border-left">
                <div className="d-flex align-items-center">
                    <p className="mb-0 font-size-10 font-weight-400 subtitle mr-3">Status</p>
                    <div className='py-3 border-right'></div>
                    <div>
                        <p id={statusId} className={`mb-0 font-size-14 font-weight-medium ml-3`}>{quoteStatusData.status || '-'}</p>
                        {quoteStatusData.application_number && <p className="mb-0 font-size-10 font-weight-300 subtitle ml-3">App ID:{quoteStatusData.application_number || '-'}</p>}
                        {channelName.includes(channel_code) &&
                            <>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3 ">Agent Name: {journeyData?.agent_name}</p>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3">Designation: {journeyData?.agent_type}</p>
                                <p className="mb-0 font-size-10 font-weight-400 subtitle ml-3">Product Name & Coverage:</p>
                                {journeyData?.product_coverage_list?.map((item) => {
                                    return (
                                        <p className="mb-0 font-size-10 font-weight-400 subtitle ml-4">{item?.product_name} {item?.coverage_percentage}%</p>
                                    )
                                })}
                            </>
                        }
                    </div>
                </div>
            </Col>

            <div className='d-none d-md-block border-right mx-md-3'></div>
            <div className='d-block d-md-none border-bottom w-100 mx-md-3'></div>

            <Col md="6" className="pr-md-1 card-inner-padding">
                <Row>
                    <Col md="6" className="pl-md-0">
                        <p className="mb-0 font-size-10 font-weight-400 subtitle">Next Actions</p>
                        <p className="mb-0 font-size-12 font-weight-400 subtitle">{quoteStatusData.next_action_text || '-'}</p>
                        {qmsDashboardPageStore.expiringDatelist[journeyData?.journey_id] &&
                            <p className="mb-0 font-size-12 font-weight-700 subtitle text-danger">{`Expiring in ${qmsDashboardPageStore.expiringDatelist[journeyData.journey_id]} Days`}</p>
                        }
                    </Col>

                    {showResumeAnalysisButton(journeyData.product_coverage_list) ?
                        (
                            <Col md={"6"} className="justify-content-md-end d-md-flex mt-4 mt-md-0 px-1" >
                                <NextButton
                                    id={buttonId}
                                    buttonText={'Resume Analysis'}
                                    className={`status-btn`}
                                    onClick={() => onClickResumeAnalysis()}
                                />
                            </Col>
                        )
                        :

                        (
                            <Col md="6" className="justify-content-md-end d-md-flex mt-4 mt-md-0">
                                {quoteStatusData.status && <NextButton
                                    id={buttonId}
                                    buttonText={quoteStatusData.button_text}
                                    className={`status-btn`}
                                    onClick={() => onViewDetailsClick()}
                                />}
                            </Col>
                        )
                    }
                </Row>
            </Col>
            <div className=' border-bottom w-100 d-none d-md-block'></div>

            {quoteStatusData.status_id !== QmsQuoteStatus.PROPOSAL_COMPLETED ? (
                <div>
                    <form className='d-none' id={`quotation-status-form-post-call-${statusId}`} action={policyResumeUrl} method={"POST"}>
                        <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
                        <input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
                        <input type='text' name='Vendor' value={localStorage.getItem(QmsStorageKeys.VENDOR)} />
                        <input type='text' name='SourceFrom' value={"QMS"} />
                        <input type='text' name='Policy_number' value={quoteStatusData.policy_number} />
                        <input type='text' name='Application_number' value={quoteStatusData.application_number} />
                        <button type='submit'>Submit</button>
                    </form>
                </div>
            ) : (
                <div></div>
            )}

            {quoteStatusData.status_id === QmsQuoteStatus.PROPOSAL_COMPLETED ? (
                <div>
                    <form className='d-none' id={`quotation-status-form-post-call-${statusId}`} action={policyAppTrackerUrl} method={"POST"}>
                        <input type='text' name='Policy_number' value={quoteStatusData.policy_number} />
                        <input type='text' name='Application_number' value={quoteStatusData.application_number} />
                        <input type='text' name='DOB' value={proposerData.dob} />
                        <input type='text' name='Reverse_URL' value={`${qmsDashboardUrl}?agent_id=${localStorage.getItem(QmsStorageKeys.AGENT_ID)}&token=${sessionStorage.getItem(StorageKeys.AUTH_TOKEN)}`} />
                        <input type='text' name='SourceFrom' value={"QMS"} />
                        <input type='text' name='Pragati_Token' value={sessionStorage.getItem(StorageKeys.AUTH_TOKEN)} />
                        <input type='text' name='LoginCode' value={localStorage.getItem(QmsStorageKeys.LOGIN_CODE)} />
                        <input type='text' name='Vendor' value={"ETLI"} />
                        <button type='submit'>Submit</button>
                    </form>
                </div>
            ) : (
                <div></div>
            )}
        </>
    )
}

export default observer(ProposerDetailsCardForApplicationInProgress)
